module.exports = __webpack_public_path__ + "static/media/CTLI_13-178w.ec19710f.jpg";